import $ from 'jquery';


export default {
    init() {
    },
    finalize() {
        console.log('login');
        //form();
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateLogin.js